import {Action} from "redux";
import {ICustomerProjectActionCreator} from "../action/customer_project_action";
import {
    GetProjectByCustomerRequest,
    CreateEntryByCustomerRequest,
    DeleteEntryByCustomerRequest,
} from "../request/project_request";

interface ICustomerProjectDispatcher {
    getProject(item: GetProjectByCustomerRequest): void;

    getEntryProjects(): void;

    createEntry(item: CreateEntryByCustomerRequest): void;

    deleteEntry(item: DeleteEntryByCustomerRequest): void;

}

class Dispatcher implements ICustomerProjectDispatcher {

    constructor(private dispatch: (action: Action) => void,
                private actionCreator: ICustomerProjectActionCreator) {

    }

    public getProject = (item: GetProjectByCustomerRequest): void => {
        this.dispatch(this.actionCreator.requestGetProjectAction(item));
    };

    public getEntryProjects = (): void => {
        this.dispatch(this.actionCreator.requestGetEntryProjectsAction());
    };

    public createEntry = (item: CreateEntryByCustomerRequest): void => {
        this.dispatch(this.actionCreator.requestCreateEntryAction(item));
    };

    public deleteEntry = (item: DeleteEntryByCustomerRequest): void => {
        this.dispatch(this.actionCreator.requestDeleteEntryAction(item));
    };


}

const createCustomerProjectDispatcher = (dispatch: (action: Action) => void, actionCreator: ICustomerProjectActionCreator): ICustomerProjectDispatcher => {
    return new Dispatcher(dispatch, actionCreator);
};

export {ICustomerProjectDispatcher, createCustomerProjectDispatcher};



// WEBPACK FOOTER //
// ./src/presentation/dispatcher/customer_project_dispatcher.ts